// import { useRecoilValueLoadable } from 'recoil'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../../../Components/ui/carousel'
import { useNavigate } from 'react-router-dom'
// import { InvestedPlansSelector } from '../../../store/InvestedPlansStore'
import { ChevronRight } from 'lucide-react'
import { useState } from 'react'
import actionCarouselData from './ActionCarouselData'
import basketRowIcon from '../../../assets/SVGS/fabits-basket-row-icon.svg'

const ActionCarousel = ({ plans, mfData, receivedData }) => {
  const navigate = useNavigate()
  // const { state: investedPlansState, contents: investedPlans } =
  //   useRecoilValueLoadable(InvestedPlansSelector)

  const [isHover, setIsHover] = useState(null)

  // const getInvestedPlanCount = (type) => {
  //   if (investedPlansState === 'hasValue' && investedPlans && investedPlans.length > 0) {
  //     const filteredPlans = investedPlans.filter((plan) => plan.planType === type)
  //     return filteredPlans.length + 1
  //   } else {
  //     return 1
  //   }
  // }

  return (
    <Carousel
      autoHeight={false}
      opts={{
        align: 'start',
        slideStep: 4,
      }}
    >
      <CarouselContent className='mt-8'>
        {actionCarouselData.map((el, index) => (
          <CarouselItem
            key={index}
            className='basis-1/2 md:basis-1/4 lg:basis-1/6 2xl:basis-1/7 px-1 py-2'
            onClick={() =>
              navigate(el.link, {
                state: { plans, mfData, receivedData },
              })
            }
          >
            <div
              className={`cursor-pointer rounded-2xl flex justify-center items-center p-4 w-40 min-h-[160px] transition-[box-shadow,border-color] duration-300 border ${
                isHover === index
                  ? 'border-[#D3DBEC] shadow-[0px_4px_16px_0px_#242F4E1F]'
                  : 'border-transparent shadow-none'
              }`}
              onMouseEnter={() => setIsHover(index)}
              onMouseLeave={() => setIsHover(null)}
            >
              <div className='rounded-2xl max-w-36 border-none w-full'>
                <div className='grid gap-4'>
                  <div className='flex justify-between'>
                    <img
                      src={basketRowIcon}
                      className='fabits-basket-row-icon rounded-full w-12 h-12'
                      alt=''
                      aria-hidden='true'
                    />
                    {isHover === index && <ChevronRight className='text-black-300 h-6 w-6' />}
                  </div>
                  <div>
                    <span className='font-semibold text-black-500 tracking-[-4%] text-base font-DMSans'>
                      {el.title}
                    </span>
                    <p className='text-black-400 text-sm text-wrap font-normal font-DMSans'>
                      {el.text}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  )
}

export default ActionCarousel
